import Cookies, { CookiesStatic } from 'js-cookie';

export const extractCglidQueryString = qs => {
  const matched = qs.match(/(&|\?)gclid=(.+?)(&.*|$)/);
  return matched && matched.length === 4
    ? decodeURIComponent(matched[2])
    : null;
};

export function initAcquisitionCookies(
  cookies: CookiesStatic = Cookies,
  date: Date = new Date(),
) {
  if (!cookies.get('tDeviceFirstPage')) {
    cookies.set('tDeviceFirstPage', window.location.href, {
      expires: 365,
      path: '/',
      domain: '.teetsh.com',
    });
    cookies.set('tDeviceFirstPageReferrer', document.referrer, {
      expires: 365,
      path: '/',
      domain: '.teetsh.com',
    });
    cookies.set('tDeviceFirstPageDate', date.toISOString(), {
      expires: 365,
      path: '/',
      domain: '.teetsh.com',
    });
  }

  if (!cookies.get('tSessionFirstPage')) {
    cookies.set('tSessionFirstPage', window.location.href, {
      path: '/',
      domain: '.teetsh.com',
    });
    cookies.set('tSessionFirstPageReferrer', document.referrer, {
      path: '/',
      domain: '.teetsh.com',
    });
    cookies.set('tSessionFirstPageDate', date.toISOString(), {
      path: '/',
      domain: '.teetsh.com',
    });
  }

  const gclidsCookie = cookies.get('tGclids');

  const cglids = gclidsCookie ? gclidsCookie.split(/\s*,\s*/) : [];
  const currentGclid = extractCglidQueryString(window.location.search);
  if (currentGclid && !cglids.includes(currentGclid)) {
    cookies.set('tGclids', [...cglids, currentGclid].join(','), {
      expires: 90,
      path: '/',
      domain: '.teetsh.com',
    });
  }
}
